<template>
    <div class="d-flex justify-content-center">
        <div class="quick-book-container">
            <v-date-picker v-model="range"
                :columns="$screens({ default: 1, lg: 2 })"
                :attributes="atts"
                :min-date="minDate"
                is-range>
                <template v-slot="{ inputValue, inputEvents, isDragging }">
                    <div class="d-inline-flex range-picker">
                        <div class="d-inline-flex">
                            <input
                                class="form-control form-control-lg"
                                :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                                :value="inputValue.start"
                                v-on="inputEvents.start"
                                placeholder="Arrival"
                            />
                            <i class="fa-thin fa-calendar-days"></i>
                            <span class="vertical-line">&nbsp;</span>
                        </div>
                        <div class="d-inline-flex">
                            <input
                                class="form-control form-control-lg"
                                :class="isDragging ? 'text-gray-600' : 'text-gray-900'"
                                :value="inputValue.end"
                                v-on="inputEvents.end"
                                placeholder="Departure"
                            />
                            <i class="fa-thin fa-calendar-days"></i>
                            <span class="vertical-line">&nbsp;</span>
                        </div>
                    </div>
                </template>
            </v-date-picker>
            <div class="guests-go">
                <div class="dropdown">
                    <button class="btn btn-lg dropdown-toggle ml-3 mr-3" type="button" id="guestsDropdown" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                        Guests
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="guestsDropdown">
                        <li class="d-flex">
                            <span class="item-title flex-grow-1">Adults</span> <div><i class="fa-thin fa-circle-minus" @click.prevent="decAdult()"></i> <span class="number">{{ adults }}</span> <i class="fa-thin fa-circle-plus" @click.prevent="incAdult()"></i></div> 
                        </li>
                        <li class="d-flex">
                            <span class="item-title flex-grow-1">Children</span> <div class="flex-end"><i class="fa-thin fa-circle-minus" @click.prevent="decChild()"></i> <span class="number">{{ child }}</span> <i class="fa-thin fa-circle-plus" @click.prevent="incChild()"></i></div>
                        </li>
                    </ul>
                </div>
                <button @click.prevent="availability" class="btn btn-lg btn-secondary qb-action">Check Availability</button>
            </div>
        </div>    
            
    </div>
</template>

<script>
    import VCalendar from 'v-calendar';
    export default {
        props: {
            url: String,
            maxguest: Number,
            rate: String,
            alturl: String
        },

        data() {
            return {
                minDate: new Date(),
                maxDate: null,
                range: null,
                atts: null,
                adults: 2,
                child: 0
            }
        },
        
        mounted() {
            
        },

        methods: {
            incAdult() {
                if(this.adults < 4) {
                    this.adults++
                }
            },
            decAdult() {
                if(this.adults > 1) {
                    this.adults--
                }
            },
            incChild() {
                if(this.child < 3) {
                    this.child++
                }
            },
            decChild() {
                if(this.child > 0) {
                    this.child--
                }
            },
            availability() {
                var arrive
                var depart

                if(this.range) {
                    arrive = moment(this.range.start).format('YYYY-MM-DD')
                    depart = moment(this.range.end).format('YYYY-MM-DD')
                } else {
                    arrive = moment().format('YYYY-MM-DD')
                    depart = moment().add(1, 'days').format('YYYY-MM-DD')
                }

                var bookingUrl
                if(this.alturl && this.alturl != '') {
                    bookingUrl = this.alturl
                } else {
                    bookingUrl = this.url
                }

                // Get the GA linker
                if("ga" in window) {
                    var tracker = ga.getAll()[0];

                    var linker = new window.gaplugins.Linker(tracker);
                    bookingUrl = linker.decorate(bookingUrl);
                }

                if(this.rate && this.rate != '') {
                    location.href = bookingUrl + '&arrival=' + arrive + '&departure=' + depart + '&adults=' + this.adults + '&children=' + this.child + '&promoCode=' + this.rate
                } else {
                    location.href = bookingUrl + '&arrival=' + arrive + '&departure=' + depart + '&adults=' + this.adults + '&children=' + this.child
                }
            }
        }
    }
</script>
